/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_TitleInputs */

const en_terms_title = /** @type {(inputs: Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const ko_terms_title = /** @type {(inputs: Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용약관`)
};

const ja_terms_title = /** @type {(inputs: Terms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Terms_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_title = /** @type {((inputs?: Terms_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_title(inputs)
	if (locale === "ko") return ko_terms_title(inputs)
	return ja_terms_title(inputs)
});